import { Box } from "@mui/material";
import { ReactFlowProvider } from "@xyflow/react";

// components
import { PlannerToolbar } from "./planner-toolbar";
import { SidebarPlanner } from "./sidebar/sidebar-planner";
import { DiagramReactFlow } from "./react-flow/diagram-react-flow";

export const Planner = ({}) => {
  return (
    <Box>
      <ReactFlowProvider>
        <SidebarPlanner />
        <DiagramReactFlow />
        <PlannerToolbar />
      </ReactFlowProvider>
    </Box>
  );
};
